// extracted by mini-css-extract-plugin
export default {"form":"form-create-receive_form__LUPsD","row":"form-create-receive_row__B7mVy","select":"form-create-receive_select__j058v","default":"form-create-receive_default__HDBBS"};